import reduxFreeFetcher from '@api/fetchers';
import fetcher from '@api/fetchers/simpleFetcher';
import { getCMSHost } from '@utils/api-helper/host';

const CMSHost = getCMSHost();

export const getPendingMethodEndpoint = (goalUid) =>
  `v1/subscriptions/pending_method/status/?goal_uid=${goalUid}`;

export const getGoalDurationMetaInfo = (goalUid) =>
  fetcher(`${CMSHost}duration-selection/${goalUid}`);

export const getAddonsMetaData = (goalList) =>
  reduxFreeFetcher(`${CMSHost}combo-info/get`, {
    requestType: 'POST',
    body: {
      goalList
    },
    useAuthToken: false
  });

export const getIconicMetaInfo = (subscriptionKey) =>
  fetcher(`${CMSHost}app-iconic/iconic-${subscriptionKey}`);

export const getIconicUsersCount = () =>
  fetcher(`${CMSHost}checkout-meta-info/iconic`);
